<template>
  <div>
    <vs-row v-if="!$store.getters.isSmallScreen">
      <vs-col class="px-6" vs-w="8" >
        <JourneyList/>
      </vs-col>
      <vs-col class="px-6" vs-w="4">
        <div v-if="showStats" class="mb-8">
          <PlannerHeader :hideAdd="true" class="mb-4">last 7 days</PlannerHeader>
          <Stats :from="statsFrom" :to="statsTo"/>
        </div>

        <PlannerHeader class="mb-4" @click="newDream">dreams</PlannerHeader>
        <DreamsList @editDream="editDream"/>
      </vs-col>
    </vs-row>

    <vs-tabs alignment="fixed" v-else>
      <vs-tab label="timeline">

        <JourneyList/>

      </vs-tab>
      <vs-tab v-if="showStats" label="stats">
        <PlannerHeader :hideAdd="true" class="mb-4">last 7 days</PlannerHeader>
        <Stats :from="statsFrom" :to="statsTo"/>
      </vs-tab>
      <vs-tab label="dreams">
        <PlannerHeader class="mb-4" @click="newDream">dreams</PlannerHeader>
        <DreamsList @editDream="editDream"/>

      </vs-tab>
  </vs-tabs>

    <DreamSidebar
      :editedEntity="editedDreamEntity"
      :open="dreamSidebarActive"
      @close="dreamSidebarActive=false"
    />
  </div>

</template>

<script>

import JourneyList from './JourneyList'
import Stats from './Stats'
import InfiniteLoading from 'vue-infinite-loading'
import Loader from '../Generic/Loader'
import DreamsList from '../Dreams/ListNew'
import Sidebar from '../Generic/Sidebar'
import DreamEditForm from '../Dreams/EditForm'
import DreamSidebar from '../Dreams/DreamSidebar'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
    InfiniteLoading,
    Loader,
    DreamsList,
    Sidebar,
    DreamEditForm,
    JourneyList,
    Stats,
    DreamSidebar
  },
  props: ['initWithDreamSidebarOpen'],
  data () {
    return {
      dreamSidebarActive: false,
      editedDreamEntity: {},
    }
  },
  watch: {
    'initWithDreamSidebarOpen': {
      immediate: true,
      handler (initWithDreamSidebarOpen) {
        if (initWithDreamSidebarOpen) {
          setTimeout(
            () => { this.dreamSidebarActive = true },
            1000
          )
        }
      }
    },
  },
  computed: {
    statsFrom () {
      return DateHelper.daysAgo(6)
    },
    statsTo () {
      return DateHelper.midnight()
    },
    showStats () {
      return true
      // return this.$store.getters.atLeastFiveVisits
    }
  },
  methods: {
    newDream () {
      console.log("newDream")
      this.editedDreamEntity = {}
      this.dreamSidebarActive = true
    },
    editDream (dream) {
      console.log("editDreameditDreameditDreameditDream")
      this.editedDreamEntity = dream
      this.dreamSidebarActive = true
    }
  },
  mounted () {

    if (window.clarity) {
      window.clarity("set", "track", "visitJourneyPage")
    }

    this.notifier.visitJourneyPage(this.$store)
  }
}
</script>
